import { type JSX } from 'react'
import { Button } from 'primereact/button'
import { useFormContext } from 'react-hook-form'

interface Props {
  label?: string
  requireDirty?: boolean
}

export function FormSaveButton({ label = 'Save', requireDirty = true }: Props): JSX.Element {
  const {
    formState: { isSubmitting, isDirty, isValid },
  } = useFormContext()
  const disabled = isSubmitting || (requireDirty && !isDirty) || !isValid
  return (
    <Button
      type="submit"
      label={isSubmitting ? 'Saving…' : label}
      loading={isSubmitting}
      disabled={disabled}
      pt={{
        root: { className: 'bg-gradient-to-r from-[#16273F] to-[#1e3a5f] hover:from-[#1D3352] hover:to-[#234060] text-white border-0 rounded-lg text-sm font-medium px-6 py-2.5 transition-all duration-200 shadow-lg hover:shadow-xl' },
        label: { className: 'font-medium' }
      } as any}
    />
  )
}
